import { TranslationFunction } from '../common/types'

export const getWebsiteSchemaHTML = (t: TranslationFunction): { __html: string } => {
    const baseUrl = t('traumBaseUrl')
    const googleSearchRoute = t('googleSearchRoute')
    const searchUrl = `${baseUrl}/${googleSearchRoute}/?search={search_term_string}&utm_source=google&utm_medium=sitelinkssuchbox&utm_campaign=sitelinkssuchbox`

    return {
        __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            url: baseUrl,
            potentialAction: {
                '@type': 'SearchAction',
                target: searchUrl,
                'query-input': 'required name=search_term_string',
            },
        }),
    }
}
